import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * BR-5: Lazy loader для CSS который не входит в initial bundle.
 *
 * angular.json: inject:false для AG Grid и Material theme CSS.
 * Эти CSS файлы собираются в dist, но НЕ добавляются в index.html.
 * Данный сервис динамически создаёт <link> теги при первом вызове.
 *
 * Singleton providedIn:root гарантирует однократную загрузку.
 */
@Injectable({ providedIn: 'root' })
export class LazyStylesService {
  private readonly document = inject(DOCUMENT);
  private readonly loaded = new Set<string>();

  /** Загрузить CSS по имени бандла (без расширения). */
  loadBundle(bundleName: string): void {
    if (this.loaded.has(bundleName)) return;
    this.loaded.add(bundleName);

    const link = this.document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${bundleName}.css`;
    link.onerror = () => {
      this.loaded.delete(bundleName);
      console.warn(`[LazyStyles] Failed to load ${bundleName}.css`);
    };
    this.document.head.appendChild(link);
  }

  /** Загрузить AG Grid CSS (ag-grid-styles.css + ag-grid-theme.css). */
  loadAgGrid(): void {
    this.loadBundle('ag-grid-styles');
    this.loadBundle('ag-grid-theme');
  }

  /** Загрузить Angular Material theme (material-theme.css). */
  loadMaterialTheme(): void {
    this.loadBundle('material-theme');
  }
}
